// extracted by mini-css-extract-plugin
export default {"title":"VerifyIdentity_title__rss-u","peida":"VerifyIdentity_peida__ZBvni","logoImg":"VerifyIdentity_logoImg__4s6vI"};